<template>
        <div class="row">
            <div class="col-12">
                <div class="swiper-container" ref="swiper">
                    <div class="swiper-wrapper">
                        <template v-for="(slide, index) in slides">
                            <div class="swiper-slide">
                                <div class="icv" :class="'image-compare-' + index">
                                    <lazy-img picture-class="icv__img icv__img-a"
                                              :image-url="slide.compareImage1">
                                        <template #additionalimages v-if="slide.compareImage1Mobile">
                                            <source media="(max-width: 767px)" :srcset="slide.compareImage1Mobile" />
                                        </template>
                                    </lazy-img>
                                    <div class="icv__wrapper">
                                        <lazy-img picture-class="icv__img icv__img-b"
                                                  :image-url="slide.compareImage2">
                                          <template #additionalimages v-if="slide.compareImage2Mobile">
                                                <source media="(max-width: 767px)" :srcset="slide.compareImage2Mobile" />
                                            </template>
                                        </lazy-img>
                                        <div class="icv__img icv__img-b icv__img--events" :style="`width: ${markerContainerWidth}px;`">
                                            <div class="position-relative w-100 h-100">
                                                <template v-for="item in slide.items">
                                                    <div v-if="item.markerY && item.markerX"
                                                         class="position-absolute icv__overlay"
                                                         :style="{
                                                            'top': `${item.markerY}%`,
                                                            'left': `${item.markerX}%`
                                                         }"
                                                         @mousedown.stop
                                                         @touchstart.stop>
                                                        <span class="icv__cta" @click="toggleOverlay($event, item.url)">
                                                            +
                                                        </span>
                                                        <div class="d-none icv__details">
                                                            <div v-if="item.itemData">
                                                                <slot :name="`reviews-${item.itemData.item.id}`"></slot>
                                                            </div>
                                                            <div v-html="item.name"></div>
                                                            <div>
                                                                <span v-if="item.itemData">
                                                                    {{ getPrice(item.itemData) }}
                                                                </span>
                                                                <a :href="item.url"
                                                                   :target="item.openInNewTab ? '_blank' : '_self'">
                                                                    Zum Produkt
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <template v-if="slides.length > 1">
                        <div class="swiper-pagination"></div>
                        <div class="swiper-button-prev"></div>
                        <div class="swiper-button-next"></div>
                    </template>
                </div>
            </div>
        </div>
</template>

<script>
import ImageCompare from '~/app/plugins/image-compare-viewer'
import { Swiper } from 'swiper'

export default
{
    props:
    {
        slides: []
    },
    data()
    {
        return {
            markerContainerWidth: 0
        }
    },
    mounted()
    {
        new Swiper(this.$refs.swiper, {
            lazy: false,
            spaceBetween: 0,
            loop: false,
            slidesPerView: 1,
            centeredSlides: false,
            allowTouchMove: false,
            navigation: {
                prevEl: this.$refs.swiper.querySelector('.swiper-button-prev'),
                nextEl: this.$refs.swiper.querySelector('.swiper-button-next')
            },
            pagination: {
                el: this.$refs.swiper.querySelector('.swiper-pagination'),
                type: 'bullets',
                clickable: true
            },
            on: {
                init: swiper => {
                    this.initCompare(swiper)
                },
                slideChange: swiper => {
                    this.initCompare(swiper)
                }
            },
        });

        this.markerContainerWidth = this.$refs.swiper.offsetWidth

        window.addEventListener('resize', () => {
            this.markerContainerWidth = this.$refs.swiper.offsetWidth
        })
    },
    methods:
    {
        initCompare(swiper) {

            this.$nextTick(() => {

                const element = this.$refs.swiper.querySelector(`.image-compare-${swiper.activeIndex}`)

                if (!element.classList.contains('standard')) {
                    new ImageCompare(element).mount()
                }
            })
        },

        toggleOverlay($e, url) {

            if(window.innerWidth < 768) {
                window.location = url
                return
            }

            $e.currentTarget
                .closest('.icv__overlay')
                .querySelector('.icv__details')
                .classList.toggle('d-none')

            $e.currentTarget.innerHTML.indexOf('+') > -1
                ? $e.currentTarget.innerHTML = '-'
                : $e.currentTarget.innerHTML = '+'
        },

        getPrice(data) {
            return this.$options.filters.specialOffer(
                data.prices.default.unitPrice.formatted, data.prices, 'unitPrice', 'formatted'
            )
        }
    }
}
</script>
